import { makeAutoObservable, runInAction } from "mobx";
import { toast } from "react-toastify";
import agent from "../api/agent";
import { basicUserPanelOptionToggle } from "../common/options/basicUserOptions";
import { AdminPanelOption } from "../models/admin";
import {
  CCProductInfo,
  CCProductInfoFormValues,
  CustomerCollection, CustomerCollectionStep5, FullCustomerCollection,
  ICCSearchForm
} from "../models/customer";
import "yup-phone";
import { store } from "./store";
import { contactInfoSchema, customerCollectionStep2Schema } from "../common/formValidations/validationSchemes";
import * as yup from 'yup';
import { getCountryCode } from "../common/options/flagOpt";
import { sanitizeColonSeperatedEmail, validateEmail } from "../common/util/emailValidate";
import { cgiRef, city, collectionDate, companyName, country, createDate, koNumber } from "../common/options/collectionOpt";
import { Pagination, PagingParams } from "../models/pagination";
export default class BasicUserStore {

  basicUserPanelOpts: AdminPanelOption[] = [];
  isBasicUserPanelOptsLoaded = false;
  loadingReport = false;
  isCustomerHasKoNumber = true;
  customerCollection: FullCustomerCollection | null = null;
  loadingCustomerCollection = false;

  isCollectionFormValid = false;
  //Collection Form Steps
  isStep1Valid = false;
  isStep2Valid = false;
  isStep3Valid = false;
  isStep4Valid = true;
  isStep5Valid = false;
  isStep6Valid = false;
  resetItAfterSubmit = false;
  emailCcError = "";

  //Collection ProductInfo Form Steps
  isProdInfoFormValid = true;
  isProdInfoStep1Valid = false;
  isProdInfoStep2Valid = true;
  isProdInfoStep3Valid = true;
  isProdInfoStep4Valid = true;

  customerCollections: FullCustomerCollection[] | [] = [];
  loadingCustomerCollections = false;
  selectedCollectionReport: FullCustomerCollection | null = null;
  orgSelectedCollectionReport: FullCustomerCollection | null = null;

  //Latest Custer Collection to pre fill values for new collection request
  latestCustomerCollection: FullCustomerCollection | null = null;

  sortOption = koNumber;
  sortValue = true;


  ccPagination: Pagination | null = null;
  ccPagingParams = new PagingParams();
  ccPage: number = 1;
  ccPredicate = new Map().set('orderBy', 'createdAtDesc');


  constructor() {
    makeAutoObservable(this);
  }


  resetBasicUserStore = () => {
    this.basicUserPanelOpts = [];
    this.resetCollectionFormDepenceis();
    this.isBasicUserPanelOptsLoaded = false;
    this.customerCollection = null;
    this.customerCollections = [];
    this.orgSelectedCollectionReport = null;
    this.latestCustomerCollection = null;
  }

  setIsCustomerHasKoNumber = (value: boolean) => {
    runInAction(() => this.isCustomerHasKoNumber = value)
  }


  setPnpCrudListPredicate = (predicate: string, value: string) => {
    this.ccPredicate.set(predicate, value);
    // switch (predicate) {
    //     case 'specType':
    //         this.predicate.set('specType', value.toUpperCase());
    //         break;
    //     case 'brandName':
    //         this.predicate.set('brandName', value.toUpperCase());
    //         break;
    //     case 'modelName':
    //         this.predicate.set('modelName', value.toUpperCase());
    //         break;
    //     case 'priceGroup':
    //         this.predicate.set('priceGroup', value.toUpperCase());
    //         break;
    // }
  }


  ccSetPage = (pageNumber: number) => {
    runInAction(() => this.ccPage = pageNumber);

  }

  setCcPagingParams = (pagingParams: PagingParams) => {
    runInAction(() => this.ccPagingParams = pagingParams);
  }


  setCcSearchPredicate = (v: ICCSearchForm) => {
    if(v){
      this.ccPredicate.clear();
      if(v.orderBy){
        this.ccPredicate.set('orderBy', 'createdAtDesc');
      } else {  
        this.ccPredicate.set('orderBy', 'createdAt');
      }
    
      this.ccPredicate.set('koNumber', v.koNumber);
      this.ccPredicate.set('refNr', v.refNr);
      this.ccPredicate.set('companyName', v.companyName);
      this.ccPredicate.set('city', v.city);
      this.ccPredicate.set('country', v.country);
    }
  }

  get ccSearchFormValues() : ICCSearchForm {
    const v: ICCSearchForm = {
      orderBy: this.ccPredicate.get('orderBy') === 'createdAt' ? false : true,
      koNumber: this.ccPredicate.get('koNumber') ?? '',
      refNr: this.ccPredicate.get('refNr') ?? '',
      companyName: this.ccPredicate.get('companyName') ?? '',
      city: this.ccPredicate.get('city') ?? '',
      country: this.ccPredicate.get('country') ?? ''
    }
    return v;
  }
  get ccParams() {
    const params = new URLSearchParams();
    params.append('pageNumber', this.ccPagingParams.pageNumber.toString());
    params.append('pageSize', this.ccPagingParams.pageSize.toString());
    this.ccPredicate.forEach((value, key) => {
      params.append(key, value);
    })
    return params;
  }

  getCustomerCollection = async (koNumber: string) => {
    if (koNumber) {
      this.loadingCustomerCollection = true;
      try {
        const result = await agent.Customer.getCustomerCollection(koNumber.toUpperCase());
        runInAction(() => {
          this.customerCollection = result;
          this.loadingCustomerCollection = false;
          this.isCustomerHasKoNumber = false;
        });
      } catch (error) {
        runInAction(() => {
          this.isCustomerHasKoNumber = false;
          this.loadingCustomerCollection = false;
        });
      }
    }

  }

  getCustomerCollectionById = async (id: string) => {
    if (id) {
      this.loadingCustomerCollection = true;
      try {
        const result = await agent.Customer.getCustomerCollectionById(id);
        runInAction(() => {
          this.customerCollection = result;
          this.loadingCustomerCollection = false;
          this.isCustomerHasKoNumber = false;
        });
      } catch (error) {
        runInAction(() => {
          this.isCustomerHasKoNumber = false;
          this.loadingCustomerCollection = false;
        });
      }
    }

  }

  getCustomerCollectionPagedList = async () => {
    this.loadingCustomerCollections = true;
    try {
      const result = await agent.Customer.getCustomerCollectionPagedList(this.ccParams);
      runInAction(() => {
        this.customerCollections = result.data.data;
        this.ccPagination = result.data.pagination;
        this.loadingCustomerCollections = false;
      });
    } catch (error) {
      runInAction(() => {
        this.loadingCustomerCollections = false;
      });
    }
  }

  clearCustomerKoNumber = () => {
    runInAction(() => this.customerCollection = null);
  }

  setCollectionFormValidity = (value: boolean, step: number, values: CustomerCollection) => {
    if (values) {
      if (step === 0) {
        const custInfo = values.contactInfo;
        contactInfoSchema
          .validate(custInfo)
          .then((value) => {
            runInAction(() => {
              if (values.cgiRefNumber && values.cgiRefNumber.length > 30) {
                this.isStep1Valid = false;
              } else {
                this.isStep1Valid = true
              }

            });
          })
          .catch((err) => {
            runInAction(() => this.isStep1Valid = false);
          });


        if (custInfo.countryDialCode && custInfo.telephoneNumber) {
          const countryCode = getCountryCode(custInfo.countryDialCode);
          if (countryCode) {
            const phoneSchema = yup.string()
              .phone(countryCode!.code, true)
              .required();

            runInAction(() => this.isStep1Valid = phoneSchema.isValidSync(custInfo.telephoneNumber));
          }
        }

        if (custInfo.emailCc) {
          let emailCc = sanitizeColonSeperatedEmail(custInfo.emailCc);
          if (!emailCc) {
            runInAction(() => {
              this.isStep1Valid = false;
              this.emailCcError = "Invalid CC emails"
            });
          } else {
            const emailArray = emailCc.split(";");
            emailArray.forEach(email => {
              if (!validateEmail(email)) {
                this.isStep1Valid = false;
                this.emailCcError = "Invalid CC emails";
                return null;
              }
            });
          }
        }
        return null;
      }

      if (step === 1) {
        if (!value) {
          runInAction(() => this.isStep2Valid = false);
          return null;
        }
        if (values.products.length > 0 || value) {
          runInAction(() => this.isStep2Valid = true);
        } else {
          runInAction(() => this.isStep2Valid = false);
        }
        return null;
      }
      if (step === 2) {
        if (values.haveFilePassword) {
          runInAction(() => this.isStep4Valid = false);
        } else {
          runInAction(() => this.isStep4Valid = true);
        }

        if (values.havePassword) {
          if (values.havePassword && values.haveFilePassword) {
            runInAction(() => this.isStep3Valid = true);
            return null;
          }
          if (!values.haveFilePassword && !values.isBiosPassword && !values.isHddPassword
            && !values.isMasterPassword && !values.isMdmComputracePassword && !values.isAutopilotPassword) {
            runInAction(() => this.isStep3Valid = false);
            return null;
          }
          if (!values.biosPassword && !values.hddPassword && !values.masterPassword && !values.mdmComputracePassword && !values.autopilotPassword) {
            runInAction(() => this.isStep3Valid = false);
            return null;
          }
        }
        runInAction(() => this.isStep3Valid = true);
        return null;
      }

      if (step === 3) {
        if (!values.haveFilePassword) {
          runInAction(() => this.isStep4Valid = true);
          return null;
        }
        if (values.haveFilePassword && values.attachments.length < 1) {
          runInAction(() => this.isStep4Valid = false);
          return null;
        }
        runInAction(() => this.isStep4Valid = true);
        return null;
      }
      if (step === 4) {
        const formStep5: CustomerCollectionStep5 = {
          collectionDate: values.collectionDate,
          collectionHourFrom: values.collectionHourFrom,
          collectionHourTo: values.collectionHourTo,
          collectionFrom: values.collectionFrom,
          collectionNote: values.collectionNote
        };

        customerCollectionStep2Schema
          .validate(formStep5)
          .then((value) => {
            runInAction(() => this.isStep5Valid = true);
          })
          .catch((err) => {
            runInAction(() => this.isStep5Valid = false);
          });
        return null;
      }
      if (step === 5) {

        if (value) {
          runInAction(() => this.isStep6Valid = true);
          return null;
        }

        if (values.otherPrepackedPalletsOrSimilar && values.pallets.length < 1) {
          runInAction(() => this.isStep6Valid = false);
          return null;
        }

        if (values.otherPrepackedPalletsOrSimilar && values.pallets.length > 0) {
          runInAction(() => this.isStep6Valid = true);
          return null;
        }
        if (!values.t1aEstimate || !values.singleBox || !values.secureTransport) {
          if (!values.securityCageBox && !values.singleBox && !values.otherPrepackedPalletsOrSimilar
            && !values.onSitePacking && !values.secureTransport) {
            runInAction(() => this.isStep6Valid = false);
            return null;
          }
          if (!values.t1aEstimate && !values.singleBox && !values.secureTransport) {
            if (values.securityCageBox || values.onSitePacking) {
              runInAction(() => this.isStep6Valid = true);
            }
          }
        } else {
          runInAction(() => this.isStep6Valid = true);
        }

        if (!values.weeeConfirmation) {
          runInAction(() => this.isStep6Valid = false);
          return null;
        } else {
          runInAction(() => this.isStep6Valid = true);
          return null;
        }

      }

    } else {
      this.isStep1Valid = false;
      this.isStep2Valid = false;
      this.isStep3Valid = false;
      this.isStep4Valid = true;
      this.isStep5Valid = false;
      this.isStep6Valid = false;
    }
  }

  setSelectedCollectionReport = (selectedCollectionReport: FullCustomerCollection) => {
    if (selectedCollectionReport) {
      runInAction(() => {
        this.selectedCollectionReport = selectedCollectionReport;
        if (selectedCollectionReport.haveFilePassword) {
          this.isProdInfoStep2Valid = false;
        }
        this.orgSelectedCollectionReport = selectedCollectionReport;
      });
    }
  }

  clearSelectedCollectionReport = () => {
    this.selectedCollectionReport = null;
    this.orgSelectedCollectionReport = null;
  }

  resetSelectedCollectionReport = () => {
    if (this.orgSelectedCollectionReport) {
      const clone = Object.assign({}, this.orgSelectedCollectionReport);
      runInAction(() => this.selectedCollectionReport = clone)
    }
  }
  updateSelectedCollectionReport = (userName: string | null, isRead: boolean, isNew: boolean) => {
    if (this.selectedCollectionReport !== undefined && this.customerCollections.length > 0) {
      const listCollection = [...this.customerCollections]
      // let uptSelCol = this.selectedCollectionReport;
      const index = this.customerCollections.findIndex(x => x.id === this.selectedCollectionReport?.id);
      if (index >= 0) {
        runInAction(() => {
          let uptSelCol = listCollection[index];
          if (isRead) {
            uptSelCol = {
              ...uptSelCol,
              customerUnReadCommentCount: 0
            }
          }
          if (userName && isNew && store.userStore.user?.fullName !== userName) {
            uptSelCol = {
              ...uptSelCol,
              customerUnReadCommentCount: uptSelCol.customerUnReadCommentCount + 1
            }
          }
          listCollection[index] = uptSelCol;
          this.customerCollections = listCollection;
          this.selectedCollectionReport = uptSelCol;
        });
      }

    }
  }

  updateProductInfoSelectedCCReport = (id: string, productInfo: CCProductInfo) => {
    if (this.selectedCollectionReport !== null && this.customerCollections.length > 0 && this.selectedCollectionReport.id === id) {
      const index = this.customerCollections.findIndex(x => x.id === id);
      if (index >= 0) {
        runInAction(() => {

          const listCollection = [...this.customerCollections];
          let uptSelectedCollection = listCollection[index];

          if (uptSelectedCollection) {
            let productInfos = uptSelectedCollection.products;
            const prodIndex = productInfos.findIndex(x => x.productType === productInfo.productType);
            if (prodIndex >= 0) {
              const uptPpInfo = productInfos[prodIndex];
              const qty: number = +uptPpInfo.quantity;
              uptPpInfo.quantity = qty + +productInfo.quantity;

              const prodInformation = (uptPpInfo.information && uptPpInfo.information.trim() !== "" && productInfo.information)
                ? uptPpInfo.information + ', ' + productInfo.quantity + ' ' + productInfo.information.trim()
                : uptPpInfo.information;

              uptPpInfo.information = prodInformation.trim();

              productInfos[prodIndex] = uptPpInfo;


            } else {
              const prodInfo = (productInfo.information && productInfo.information.trim() !== "")
                ? productInfo.quantity + ' ' + productInfo.information.trim() : "";

              productInfos.push({ productType: productInfo.productType, quantity: productInfo.quantity, information: prodInfo });
              // uptSelectedCollection.products = productInfos;
              // this.selectedCollectionReport = uptSelectedCollection;
            }

            uptSelectedCollection = {
              ...uptSelectedCollection,
              products: productInfos,
              productType: '',
              quantity: 1,
              information: ''
            }
            this.selectedCollectionReport = uptSelectedCollection;
          }
        });
      }
    }
  }

  setProductInfoFormValidity = (value: boolean, step: number, values: CCProductInfoFormValues) => {
    if (values) {

      if (step === 0) {

        if (values.havePassword) {
          if (values.havePassword && values.haveFilePassword) {
            runInAction(() => this.isProdInfoStep1Valid = true);
            return null;
          }
          if (!values.haveFilePassword && !values.isBiosPassword && !values.isHddPassword
            && !values.isMasterPassword && !values.isMdmComputracePassword && !values.isAutopilotPassword) {
            runInAction(() => this.isProdInfoStep1Valid = false);
            return null;
          }
          if (!values.biosPassword && !values.hddPassword && !values.masterPassword
            && !values.mdmComputracePassword && !values.autopilotPassword) {
            runInAction(() => this.isProdInfoStep1Valid = false);
            return null;
          }
        }
        runInAction(() => this.isProdInfoStep1Valid = true);
        return null;
      }
      if (step === 1) {
        if (!values.haveFilePassword) {
          runInAction(() => this.isProdInfoStep2Valid = true);
          return null;
        }
        if (values.haveFilePassword && values.attachments.length < 1) {
          runInAction(() => this.isProdInfoStep2Valid = false);
          return null;
        }
        runInAction(() => this.isProdInfoStep2Valid = true);
        return null;
      }
      if (step === 2) {

        if (!value) {
          runInAction(() => this.isProdInfoStep3Valid = false);
          return null;
        }
        if (value) {
          runInAction(() => this.isProdInfoStep3Valid = true);
          return null;
        }

      }
      if (step === 3) {
        if (value) {
          runInAction(() => this.isProdInfoStep4Valid = true);
          return null;
        }
        if (values.otherPrepackedPalletsOrSimilar && values.pallets.length < 1) {
          runInAction(() => this.isProdInfoStep4Valid = false);
          return null;
        }
        if (values.otherPrepackedPalletsOrSimilar && values.pallets.length > 0) {
          runInAction(() => this.isProdInfoStep4Valid = true);
          return null;
        }
        if (!values.t1aEstimate || !values.singleBox || !values.secureTransport) {
          if (!values.securityCageBox && !values.singleBox && !values.otherPrepackedPalletsOrSimilar
            && !values.onSitePacking && !values.secureTransport) {
            runInAction(() => this.isProdInfoStep4Valid = false);
          }

          if (!values.t1aEstimate && !values.singleBox && !values.secureTransport) {
            if (values.securityCageBox || values.onSitePacking) {
              runInAction(() => this.isProdInfoStep4Valid = true);
            }
          }

        } else {
          runInAction(() => this.isProdInfoStep4Valid = true);
        }


      }
    } else {
      this.isProdInfoStep1Valid = false;
      this.isProdInfoStep3Valid = false;
    }
  }


  resetCollectionFormDepenceis = () => {
    this.isCollectionFormValid = false;

    this.isStep2Valid = false;
    this.isStep3Valid = false;
    this.isStep4Valid = false;
    this.isStep6Valid = false;
    this.isProdInfoStep1Valid = true;
    this.isProdInfoStep2Valid = true;
    this.resetItAfterSubmit = true;
    if (this.latestCustomerCollection) {
      this.isStep1Valid = true;
      this.isStep5Valid = true;
    } else {
      this.isStep1Valid = false;
      this.isStep5Valid = false;
    }
  }

  resetResetItAfterSubmit = () => {
    this.resetItAfterSubmit = false;
  }


  loadBasicUserPanelOptions = () => {
    const opts = basicUserPanelOptionToggle();
    this.basicUserPanelOpts = opts;
    this.isBasicUserPanelOptsLoaded = true;
  }

  setBasicUserPanelOptions = (optKey: string) => {
    const newArr = [...this.basicUserPanelOpts];
    const previousSelectedIndex = newArr.findIndex(x => x.toggle);
    const selectedIndex = newArr.findIndex(x => x.key === optKey);
    if (selectedIndex >= 0) {
      newArr[selectedIndex].toggle = true;
    }
    if (previousSelectedIndex >= 0 && previousSelectedIndex !== selectedIndex) {
      newArr[previousSelectedIndex].toggle = false;
    }
    runInAction(() => this.basicUserPanelOpts = newArr);
  }


  uploadCollectionReportWithFiles = async (data: CustomerCollection) => {
    this.loadingReport = true;
    // let status = false;
    try {
      let formData = new FormData();
      // Object.entries(data).forEach(
      //   ([key, value]) => {
      //     if (key !== "attachments" && key !== 'contactInfo' && key !== 'productInfo') {
      //       formData.append(key, value)
      //     }          
      //   }
      // );

      // Object.entries(data.contactInfo).forEach(
      //   ([key, value]) => {
      //     formData.append(`contactInfo[${key}]`, value)
      //   }
      // );

      if (data!.attachments!.length > 0) {
        data.attachments.forEach(element => {
          formData.append('attachments', element)
        });
      }
      // const attachments = data.attachments;
      data = {
        ...data,
        attachments: []
      };
      const collectionId = await agent.Customer.createCollection(data);
      if (collectionId) {
        formData.append('id', collectionId)
        await agent.Customer.sendCustomerCollectionEmail(formData);
      }
      runInAction(() => {

        this.loadingReport = false;
        toast.success("Data saved successfully");
      });
      // status = true;
      this.resetCollectionFormDepenceis();
    } catch (error) {
      runInAction(() => {
        this.loadingReport = false;
      });
      // status = false;
      throw error;
    }
  }

  // loadCollectionReports = async () => {
  //   this.loadingCustomerCollections = true;
  //   try {
  //     const result = await agent.Customer.getCustomerCollectionList();
  //     runInAction(() => {
  //       this.customerCollections = result;
  //       if (result.length > 0) {
  //         this.setLatestCustomerCollection(result[0]);
  //       }

  //       this.loadingCustomerCollections = false;
  //     });
  //   } catch (error) {
  //     runInAction(() => {
  //       this.loadingCustomerCollections = false;
  //     });
  //   }
  // }

  loadLatestCustomerCollection = async () => {
    this.loadingCustomerCollections = true;
    try {
      const result = await agent.Customer.getLatestCustomerCollection();
      runInAction(() => {
        if (result) {
          this.setLatestCustomerCollection(result);
        }
        this.loadingCustomerCollections = false;
      });
    } catch (error) {
      runInAction(() => {
        this.loadingCustomerCollections = false;
      });
    }
  }

  setLatestCustomerCollection = (collection: FullCustomerCollection) => {
    if (collection) {
      let contactInfo = collection.contactInfo;
      contactInfo = {
        ...contactInfo,
        emailCc: contactInfo.emailCc ?? '',
        mobileNumber: contactInfo.mobileNumber ?? '',
      };

      collection = {
        ...collection,
        contactInfo: contactInfo,
        cgiRefNumber: collection.cgiRefNumber ?? '',
        koNumber: '',
        isDone: false,
        collectionDate: new Date(),
        collectionNote: collection.collectionNote ?? '',
        havePassword: true,
        haveFilePassword: false,
        isBiosPassword: false,
        biosPassword: '',
        isHddPassword: false,
        hddPassword: '',
        isMasterPassword: false,
        masterPassword: '',
        isMdmComputracePassword: false,
        mdmComputracePassword: '',
        isAutopilotPassword: false,
        autopilotPassword: '',
        products: [],
        productType: '',
        quantity: 0,
        information: "",
        t1aEstimate: false,
        securityCageBox: false,
        securityCageBoxOption1: false,
        securityCageBoxOption2: false,
        securityCageBoxOption3: false,
        securityCageBoxQty1: 0,
        securityCageBoxQty2: 0,
        securityCageBoxQty3: 0,
        additionalPackingMaterial: false,
        additionalPackingMaterialText: '',
        singleBox: false,
        singleBoxQty: 0,
        otherPrepackedPalletsOrSimilar: false,
        otherPrepackedPalletsOrSimilarFreetext: '',
        pallets: [],
        palletType: '',
        //All are in Centimeters
        palletWidth: 0,
        palletHeight: 0,
        palletLength: 0,
        palletWeight: 0,
        palletQuantity: 0,
        palletInformation: '',
        onSitePacking: false,
        secureTransport: false,
        createdAt: new Date(),
        attachments: [],
        isGoodReceived: "No",
        isPreScanDone: false,
        customerUnReadCommentCount: 0,
        t1aUnReadCommentCount: 0,
        isReadyToCollect: false,
        weeeConfirmation: false,
        error: null,
      }
      this.latestCustomerCollection = collection;
      //Make some step valid, because we know the form is valid already
      this.isStep1Valid = true;
      this.isStep5Valid = true;
    }
  }
  uploadUpdatedCustomerCollection = async (customerCollection: FullCustomerCollection) => {
    this.loadingReport = true;
    let status = false;

    try {
      let formData = new FormData();

      if (customerCollection!.attachments!.length > 0) {
        customerCollection.attachments.forEach(element => {
          formData.append('attachments', element)
        });
      }

      customerCollection = {
        ...customerCollection,
        attachments: []
      };

      const customerCollectionId = await agent.Customer.updateCustomerCollection(customerCollection);

      if (customerCollectionId) {

        formData.append('id', customerCollectionId)
        await agent.Customer.sendCustomerCollectionEmail(formData);
      }

      runInAction(() => {

        if (customerCollection.id) {
          if (customerCollection.t1aEstimate || customerCollection.secureTransport || customerCollection.singleBox) {
            customerCollection = {
              ...customerCollection,
              securityCageBox: false,
              securityCageBoxOption1: false,
              securityCageBoxOption2: false,
              securityCageBoxOption3: false,
              securityCageBoxQty1: 0,
              securityCageBoxQty2: 0,
              securityCageBoxQty3: 0,
              additionalPackingMaterial: false,
              additionalPackingMaterialText: '',
              otherPrepackedPalletsOrSimilar: false,
              otherPrepackedPalletsOrSimilarFreetext: '',
              onSitePacking: false,
            };

            if (customerCollection.t1aEstimate) {
              customerCollection = {
                ...customerCollection,
                singleBox: false,
                secureTransport: false,
              }
            }
            if (customerCollection.secureTransport) {
              customerCollection = {
                ...customerCollection,
                t1aEstimate: false,
                singleBox: false
              }
            }
            if (customerCollection.singleBox) {
              customerCollection = {
                ...customerCollection,
                t1aEstimate: false,
                secureTransport: false,
              }
            }

          }
          let updateCustomerCollections = [...this.customerCollections];

          let index = updateCustomerCollections.findIndex(x => x.id === customerCollection.id);

          if (index >= 0) {
            updateCustomerCollections[index] = customerCollection;
            runInAction(() => {
              this.selectedCollectionReport = customerCollection;
              this.orgSelectedCollectionReport = customerCollection;
              this.customerCollections = updateCustomerCollections;
              this.resetCollectionFormDepenceis();
            });
          }
        }
        this.loadingReport = false;
        toast.success("Collection Report updated successfully")
      });
      status = true;
      this.resetCollectionFormDepenceis();
    } catch (error) {
      runInAction(() => {
        this.loadingReport = false;
      });
      status = false;
      throw error;
    } finally {
      return status;
    }
  }
  //   } catch (error) {
  //     console.log(error);
  //     this.loadingReport = false;
  //     this.resetCollectionFormDepenceis();
  //   }
  // }

  toggleIsReadyToCollect = async (id: string) => {
    try {
      await agent.Customer.toggleIsReadyToCollect(id);
      runInAction(() => {
        if (id) {
          let updateCustomerCollections = [...this.customerCollections];
          let index = updateCustomerCollections.findIndex(x => x.id === id);
          if (index >= 0) {
            const customerCollection = updateCustomerCollections[index];
            customerCollection.isReadyToCollect = !customerCollection.isReadyToCollect;
            updateCustomerCollections[index] = customerCollection;
            runInAction(() => {
              this.customerCollections = updateCustomerCollections;
            });
          }
        }
        toast.success("Collection Report updated successfully");
      })
    } catch (error) {
      console.log(error);
    }
  }

  sortcustomerCollection = (type: string) => {
    if (this.sortOption !== type) {
      this.sortValue = true;
    }
    else {
      this.sortValue = !this.sortValue;
    }
    runInAction(() => {
      this.sortOption = type;
      if (type === koNumber) {
        this.customerCollections = this.customerCollections.sort((a, b) => {
          if (this.sortValue) {
            if (a.koNumber < b.koNumber)
              return -1;
            if (a.koNumber > b.koNumber)
              return 1;
            return 0;
          }
          else {

            if (a.koNumber > b.koNumber)
              return -1;
            if (a.koNumber < b.koNumber)
              return 1;
            return 0;
          }
        });
      }
      if (type === cgiRef) {
        this.customerCollections = this.customerCollections.sort((a, b) => {
          if (this.sortValue) {
            if (a.cgiRefNumber < b.cgiRefNumber)
              return -1;
            if (a.cgiRefNumber > b.cgiRefNumber)
              return 1;
            return 0;
          }
          else {

            if (a.cgiRefNumber > b.cgiRefNumber)
              return -1;
            if (a.cgiRefNumber < b.cgiRefNumber)
              return 1;
            return 0;
          }
        });
      }
      if (type === companyName) {
        this.customerCollections = this.customerCollections.sort((a, b) => {
          if (this.sortValue) {
            if (a.contactInfo.companyName < b.contactInfo.companyName)
              return -1;
            if (a.contactInfo.companyName > b.contactInfo.companyName)
              return 1;
            return 0;
          }
          else {
            if (a.contactInfo.companyName > b.contactInfo.companyName)
              return -1;
            if (a.contactInfo.companyName < b.contactInfo.companyName)
              return 1;
            return 0;
          }
        });
      }
      if (type === city) {
        this.customerCollections = this.customerCollections.sort((a, b) => {
          if (this.sortValue) {
            if (a.contactInfo.city < b.contactInfo.city)
              return -1;
            if (a.contactInfo.city > b.contactInfo.city)
              return 1;
            return 0;
          }
          else {
            if (a.contactInfo.city > b.contactInfo.city)
              return -1;
            if (a.contactInfo.city < b.contactInfo.city)
              return 1;
            return 0;
          }
        });
      }
      if (type === country) {
        this.customerCollections = this.customerCollections.sort((a, b) => {
          if (this.sortValue) {
            if (a.contactInfo.country < b.contactInfo.country)
              return -1;
            if (a.contactInfo.country > b.contactInfo.country)
              return 1;
            return 0;
          }
          else {
            if (a.contactInfo.country > b.contactInfo.country)
              return -1;
            if (a.contactInfo.country < b.contactInfo.country)
              return 1;
            return 0;
          }
        });
      }
      if (type === createDate) {
        this.customerCollections = this.customerCollections.sort((a, b) => {

          const dateA = new Date(a.createdAt || new Date());
          const dateB = new Date(b.createdAt || new Date());

          if (this.sortValue) {
            return dateA.getTime() - dateB.getTime();
          } else {
            return dateB.getTime() - dateA.getTime();
          }
        });
      }
      if (type === collectionDate) {
        this.customerCollections = this.customerCollections.sort((a, b) => {

          const dateA = new Date(a.collectionDate || new Date());
          const dateB = new Date(b.collectionDate || new Date());

          if (this.sortValue) {
            return dateA.getTime() - dateB.getTime();
          } else {
            return dateB.getTime() - dateA.getTime();
          }
        });
      }

    })
  }
}
